import anchorme from 'anchorme';
import sanitizeHtml from 'sanitize-html';
import defaultSanitizeOptions from './defaultSanitizeOptions';

const linkifyText = value => {
  if (typeof value !== 'string') {
    return value;
  }

  const anchorMeOptions = {
    attributes: {
      target: '_blank'
    }
  };

  const sanitizeOptions = defaultSanitizeOptions();
  sanitizeOptions.allowedAttributes.a.push('onclick', 'onmousedown', 'onmouseup');
  const originalATransformer = sanitizeOptions.transformTags.a;
  sanitizeOptions.transformTags.a = (tagName, attributes, ...rest) => {
    const original = originalATransformer(tagName, attributes, ...rest);
    return {
      ...original,
      attribs: {
        ...original.attribs,
        onclick: 'event.stopPropagation();',
        onmousedown: 'event.stopPropagation();',
        onmouseup: 'event.stopPropagation();'
      }
    };
  };
  return sanitizeHtml(anchorme({ input: value, options: anchorMeOptions }), sanitizeOptions);
};

export default linkifyText;
